import { render, staticRenderFns } from "./ActiveEmail.vue?vue&type=template&id=51ddd665"
import script from "./ActiveEmail.vue?vue&type=script&lang=js"
export * from "./ActiveEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports